import { Button } from 'UIPackage/MainModule/components/Button';

import styles from './FieldReplaceAlert.module.scss';

interface IFieldReplaceAlertProps {
  className?: string;
  text: string;
  onReplaceButtonClick?: () => void;
}

export const FieldReplaceAlert = ({ className, text, onReplaceButtonClick }: IFieldReplaceAlertProps) => (
  <div className={className ? `${styles.FieldReplaceAlert} ${className}` : styles.FieldReplaceAlert}>
    <div className={styles.Text}>{text}</div>
    <Button
      className={styles.ReplaceButton}
      text="Заменить"
      color="warning"
      size="small"
      type="button"
      onClick={onReplaceButtonClick}
    />
  </div>
);
